import React from "react";
import { Select, MenuItem, OutlinedInput } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface Option {
  label: string;
  value: string;
}

interface CustomSelectProps<T> {
  value: Option | null;
  setSelectedValue: (e: any) => void;
  options: Option[];
  placeholder: string;
  selected: string;
}

function CustomSelect<T>({
  value,
  setSelectedValue,
  options,
  placeholder,
  selected,
  ...props
}: CustomSelectProps<T>) {
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedOption = options.find(
      (option) => option.value === event.target.value
    );
    if (selectedOption) {
      setSelectedValue(selectedOption);
    }
  };

  return (
    <Select
      displayEmpty
      value={value ? value.value : ""}
      onChange={(e: any) => handleChange(e)}
      input={<OutlinedInput />}
      renderValue={(selected: any) => {
        if (!selected || selected.length === 0) {
          return <em style={{ color: "rgba(0, 0, 0, 0.6)" }}>{placeholder}</em>;
        }
        const selectedOption = options.find(
          (option) => option.value === selected
        );
        return selectedOption ? selectedOption.label : "";
      }}
      IconComponent={KeyboardArrowDownIcon}
      inputProps={{ "aria-label": "Without label" }}
      sx={{
        width: "100%",
        height: "42px",
        backgroundColor: "var(--white)",
        borderRadius: "6px",
        boxShadow: "0px 4px 14px 0px rgba(0, 0, 0, 0.05)",
        ".KeyboardArrowDownIcon": {
          color: "black",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "transparent",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "transparent",
        },
        ".MuiOutlinedInput-root": {
          borderColor: "transparent",
        },
        "& fieldset": {
          border: "none",
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            "& .MuiMenuItem-root:first-of-type": {
              backgroundColor: "transparent",
            },
            "& .MuiMenuItem-root.Mui-selected": {
              backgroundColor: "var(--soft-rose)",
            },
          },
        },
      }}
      {...props}
    >
      <MenuItem disabled value="">
        <em>{placeholder}</em>
      </MenuItem>
      {options.map((option: Option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}

export default CustomSelect;
